module.exports = __webpack_public_path__ + "static/img/mouth_09.5543940.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_09.png
// module id = +wDU
// module chunks = 0